import { type ReactNode } from 'react';
import { resolveKpiGridClassName } from './resolveKpiGridClassName.js';

export interface KpiGridProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function KpiGrid({ children, className }: KpiGridProps): JSX.Element {
  return (
    <div className={resolveKpiGridClassName(className)} data-testid="kpi-grid">
      {children}
    </div>
  );
}
